import React from "react";
import Navbar from "./global-components/navbar-v3";
import PageHeader from "./global-components/page-header";
import GeneralEnquiryForm from "./section-components/general-enquiry";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";

const GeneralEnquiryPage = () => {
  return (
    <div>
      <Navbar />
      <PageHeader headertitle="General Enquiry" />
      <GeneralEnquiryForm />
      <CallToActionV1 />
      <Footer />
    </div>
  );
};

export default GeneralEnquiryPage;
